export default class Segment {
  id: number;
  name: string;
  tenantId: number;
  usersIds: number[];
}
